export const baseURL = 'https://admin.sadaynaal.com';
// export const baseURL = 'https://admin.chefadmin.com';
export const token = 'Bearer 473|nducceUl4z2qdWw2YaoxkNyWCL4KvbITfV1rnIQ8';
